import { render, staticRenderFns } from "./Fitty.vue?vue&type=template&id=039c9178&scoped=true&"
import script from "./Fitty.vue?vue&type=script&lang=js&"
export * from "./Fitty.vue?vue&type=script&lang=js&"
import style0 from "./Fitty.vue?vue&type=style&index=0&id=039c9178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c9178",
  null
  
)

export default component.exports